import React, { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

function LandingLayout() {
  const containerRef = useRef(null);
  const { pathname } = useLocation();

  useEffect(() => {
    containerRef.current?.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div
      ref={containerRef}
      className="overflow-y-auto min-h-screen h-screen w-full pb-0 font-lexendS bg-[#fff]"
      id="landing-container"
    >
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
}

export default LandingLayout;
